import React from 'react';
export function Tomos() {
  const tomos = [{
    num: 'TOMO 01',
    title: '📘 Psicología del Algoritmo Espiritual',
    desc: 'Entendé cómo funciona el algoritmo y cómo usarlo a favor de tu mensaje sin traicionar tu fe.'
  }, {
    num: 'TOMO 02',
    title: '📗 El Método Caballo de Troya',
    desc: 'El sistema para crear contenido que atrae por estética y retiene por mensaje espiritual.'
  }, {
    num: 'TOMO 03',
    title: '📙 Guiones de Alto Impacto',
    desc: 'Scripts completos para Reels y carruseles según el tipo de persona que querés alcanzar.'
  }, {
    num: 'TOMO 04',
    title: '📕 Branding del Reino',
    desc: 'Diseñá una identidad visual moderna, coherente y con autoridad cristiana real.'
  }, {
    num: 'TOMO 05',
    title: '📓 Evangelismo en DMs',
    desc: 'Convertí reacciones y mensajes en conversaciones profundas y espiritualmente significativas.'
  }, {
    num: 'TOMO 06',
    title: '📔 Consistencia y Escalabilidad',
    desc: 'El sistema para sostener tu cuenta con propósito durante meses sin agotarte ni desaparecer.'
  }];
  return <section className="py-[60px] px-5 bg-dark" data-id="element-164">
      <div className="max-w-[760px] mx-auto" data-id="element-165">
        <p className="text-[13px] tracking-[3px] text-gold mb-2 text-center font-bold" data-id="element-166">
          🏆 MISIÓN INFLUENCIA™ MEGAPACK
        </p>
        <h2 className="text-[22px] md:text-[34px] font-black text-center mb-3 text-text-heading" data-id="element-167">
          6 Tomos + 5 Bonos —<br data-id="element-168" />
          <span className="text-gold" data-id="element-169">
            El sistema completo de evangelismo digital cristiano
          </span>
        </h2>
        <p className="text-center text-text-muted text-[15px] mb-9 leading-relaxed" data-id="element-170">
          Todo resuelto.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6" data-id="element-171">
          {tomos.map((tomo, i) => <div key={i} className="bg-card border border-cardBorder border-t-[3px] border-t-gold rounded-xl p-6 hover:border-gold/50 transition-colors" data-id="element-172">
              <p className="text-[11px] tracking-[3px] text-gold font-bold mb-1.5" data-id="element-173">
                {tomo.num}
              </p>
              <p className="text-[17px] font-extrabold text-white mb-2.5" data-id="element-174">
                {tomo.title}
              </p>
              <p className="text-[14px] text-text-muted leading-relaxed" data-id="element-175">
                {tomo.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-card border border-cardBorder rounded-xl p-6 mt-6" data-id="element-176">
          {['Método aplicable desde el día 1', 'Ejemplos reales adaptados al contexto argentino', 'Lenguaje moderno sin jerga religiosa', '100% orientado a no creyentes y buscadores espirituales'].map((item, i) => <p key={i} className={`text-[14px] text-text-secondary py-2 flex items-start gap-2 ${i !== 3 ? 'border-b border-divider' : ''}`} data-id="element-177">
              <span data-id="element-178">✅</span> <span data-id="element-179">{item}</span>
            </p>)}
        </div>
      </div>
    </section>;
}